(function () {
    var copyText = {
        $target: null,
        $toggle: null,

        init: function () {
            copyText.$toggle = $('.copy__btn');
            copyText.$target = $('.copy__text');
            copyText.control();
        },

        control: function () {
            $(document).on('click touchstart', '.copy__btn', function () {
                copyText.$toggle = $(this);
                copyText.$toggle.off('focusout');
                copyText.copyLink();
            });
        },

        copyLink: function () {
            let $wrapper = copyText.$toggle.closest('.copy__text-wrapper'),
                copyData = '';
            if ($wrapper.length) {
                copyText.$target = $wrapper.find('.copy__text');
                copyData = copyText.$target.html();
                if (/<\/?[a-z][\s\S]*>/i.test(copyText.$target.html())) {
                    copyData = copyText.$target.text();
                }

                // copy export citation content
                if (copyText.$target.is('.csl-response')) {
                    if ($wrapper.find('.csl-right-inline').length) {
                        copyText.$target = $wrapper.find('.csl-right-inline');
                        copyData = copyText.$target.html();

                        if (/<\/?[a-z][\s\S]*>/i.test(copyText.$target.html())) {
                            copyData = copyText.$target.text();
                        }
                    } else if ($wrapper.find('.csl-entry').length) {
                        copyText.$target = $wrapper.find('.csl-entry');
                        copyData = copyText.$target.html();

                        if (/<\/?[a-z][\s\S]*>/i.test(copyText.$target.html())) {
                            copyData = copyText.$target.text();
                        }
                    }

                    if (copyText.$target.length > 1) {
                        let copyMultiText = '';
                        copyText.$target.each(function () {
                            let $this = $(this);

                            if (/<\/?[a-z][\s\S]*>/i.test($this.html())) {
                                copyMultiText += $this.text() + '\n\n';
                            } else {
                                copyMultiText += $this.html() + '\n\n';
                            }
                        });
                        copyData = copyMultiText;
                    }
                }
            }

            copyData = copyText.additionalCopyDataFormat(copyData);

            const textarea = document.createElement('textarea');
            textarea.id = 'temp_element';
            textarea.style.height = 0;
            textarea.value = copyData;

            document.body.appendChild(textarea);
            let selector = document.querySelector('#temp_element');

            let range;
            let selection;
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                selector.setAttribute('readonly', '');

                range = document.createRange();
                range.selectNodeContents(selector);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                selector.setSelectionRange(0, 999999);

                selector.removeAttribute('readonly');
            } else {
                selector.select();
            }
            document.execCommand('copy');
            document.body.removeChild(textarea);
            copyText.$toggle.focus();
        },
        additionalCopyDataFormat: function (copyData) {
            return copyData;
        },
    };

    UX.copyText = copyText; // add to global namespace
})();
